import api from './api';

export const getCashOuts = async (params = {}) => {
  try {
    const response = await api.get('/cash-outs', { params });
    return response.data;
  } catch (error) {
    console.error('Error fetching cash outs:', error);
    throw error;
  }
};

export const getCashOut = async (id) => {
  try {
    const response = await api.get(`/cash-outs/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching cash out:', error);
    throw error;
  }
};

export const createCashOut = async (data) => {
  try {
    const response = await api.post('/cash-outs', data);
    return response.data;
  } catch (error) {
    console.error('Error creating cash out:', error);
    throw error;
  }
};

export const updateCashOut = async (id, data) => {
  try {
    const response = await api.put(`/cash-outs/${id}`, data);
    return response.data;
  } catch (error) {
    console.error('Error updating cash out:', error);
    throw error;
  }
};

export const deleteCashOut = async (id) => {
  try {
    const response = await api.delete(`/cash-outs/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting cash out:', error);
    throw error;
  }
};

export const getChangerStatus = async (params = {}) => {
  try {
    const response = await api.get('/cash-outs/changer-status', { params });
    return response.data;
  } catch (error) {
    console.error('Error fetching changer status:', error);
    throw error;
  }
};

export const updateChangerFill = async (data) => {
  try {
    const response = await api.put('/cash-outs/changer-fill', data);
    return response.data;
  } catch (error) {
    console.error('Error updating changer fill:', error);
    throw error;
  }
};

export const getSummary = async (params = {}) => {
  try {
    const response = await api.get('/cash-outs/summary', { params });
    return response.data;
  } catch (error) {
    console.error('Error fetching summary:', error);
    throw error;
  }
};
